import { Heart, ChevronUp, Play } from "lucide-react";

/**
 * HandNavFooter — réplica del footer nativo de PPPoker history detail.
 *
 * [♥ collected/total]  [◀ current/total ▶]  [⌃ collapse]
 */
export function HandNavFooter({
  collectedCount = 0,
  collectedTotal = 100,
  currentIndex,
  totalHands,
  onPrev,
  onNext,
  onCollapse,
  onToggleHeart,
}) {
  return (
    <footer
      className="flex items-center justify-between gap-3 px-3 py-2 border-t border-white/10 bg-slate-900/30"
      data-testid="hand-nav-footer"
    >
      <button
        onClick={onToggleHeart}
        className="flex items-center gap-1.5 text-slate-300 hover:text-rose-400 transition-colors"
        data-testid="footer-heart-btn"
      >
        <Heart className="h-5 w-5" />
        <span className="text-[12px] tabular-nums">
          {collectedCount}/{collectedTotal}
        </span>
      </button>

      <div className="flex items-center gap-3">
        <button
          onClick={onPrev}
          className="text-emerald-400 hover:text-emerald-300 disabled:text-slate-600 transition"
          disabled={!onPrev}
          data-testid="footer-prev-btn"
          aria-label="Mano anterior"
        >
          <Play className="h-5 w-5 rotate-180" fill="currentColor" />
        </button>
        {currentIndex != null && totalHands != null && (
          <span className="text-[13px] tabular-nums text-slate-200" data-testid="footer-counter">
            {currentIndex}/{totalHands}
          </span>
        )}
        <button
          onClick={onNext}
          className="text-slate-400 hover:text-slate-300 disabled:text-slate-600 transition"
          disabled={!onNext}
          data-testid="footer-next-btn"
          aria-label="Mano siguiente"
        >
          <Play className="h-5 w-5" fill="currentColor" />
        </button>
      </div>

      <button
        onClick={onCollapse}
        className="text-emerald-400 hover:text-emerald-300 transition-colors"
        data-testid="footer-collapse-btn"
        aria-label="Colapsar"
      >
        <ChevronUp className="h-5 w-5" />
      </button>
    </footer>
  );
}
